<template lang="pug">
  #chapter3
    // Navbar
    BlogsNavBar

    // Intro
    #ch3intro.container-fluid
      .row.d-flex.justify-content-center.align-items-center.mt-5
        .col-12.d-flex.justify-content-center.align-items-center.mt-5
          img.chapter-logo(src="/assets/img/chapter2/la-respuesta.png")
        .col-12
          p.title
            span.d-block.top {{titleTop}}
            span.d-block.bottom {{titleBottom}}
        .col-12
          p.author {{blogData._author}}
        .col-12
          p 5 de mayo de 2020
        .col-12.d-flex.justify-content-center.align-items-center
          img.intro-illustration(src="/assets/img/mapa-intro.png")
        .col-12
          p.copyright Ilustración de Rafaela López
        .col-12.col-lg-8
          p.text(v-html="blogData._intro")
    // Section 1
    #ch3section1.section.container-fluid
      .row.d-flex.justify-content-center.align-items-center
        .col-12.col-lg-8.mt-5
          p.d-inline.px-4.py-2.title {{blogData._subtitle1}}
        .col-12.col-lg-8
          p.mt-5.text(v-html="blogData._content1")
          //c3_01
          img(src="/assets/img/chapter3/Grafs_Estados_10_edad_vulnerable (1) (1).svg")
          p.mt-5.text(v-html="blogData._content1_1")
          //c3_02
          img(src="/assets/img/chapter3/Grafs_Estados_9_estatal_vulnerable (1).svg")
          p.mt-5.text(v-html="blogData._content1_2")
      .row.d-flex.justify-content-center.align-items-center.default-background
        .col-12.col-lg-8
          img(src="/assets/img/chapter3/c3_03.svg")
    //Section 2
    #ch3section2.section.container-fluid
      .row.d-flex.justify-content-center.align-items-center
        .col-12.col-lg-8.mt-5
          p.d-inline.px-4.py-2.title {{blogData._subtitle2}}
        .col-12.col-lg-8
          p.mt-5.text(v-html="blogData._content2")
          //c3_04
          img(src="/assets/img/chapter3/Grafs_Estados_7_scatt (1).svg")
          p.mt-5.text(v-html="blogData._content2_1")
          //c3_05
          img(src="/assets/img/chapter3/Grafs_Estados_5_enfermeras (1) (1) (1).svg")
          p.mt-5.text(v-html="blogData._content2_2")
          //c3_06
          img(src="/assets/img/chapter3/Grafs_Estados_4_medicos (2).svg")
    //Section 3
    #ch3section3.section.container-fluid
      .row.d-flex.justify-content-center.align-items-center
        .col-12.col-lg-8.mt-5
          p.d-inline.px-4.py-2.title {{blogData._subtitle3}}
        .col-12.col-lg-8
          p.mt-5.text(v-html="blogData._content3")
    #ch3interactive.section.container-fluid.py-5
      Scatter
    //Section 4
    #ch3section4.section.container-fluid.mb-5
      .row.d-flex.justify-content-center.align-items-center
        .col-12.col-lg-8.mt-5
          p.d-inline.px-4.py-2.title {{blogData._subtitle4}}
        .col-12.col-lg-8
          p.mt-5.text(v-html="blogData._content4")


          p.mt-5.text.font-weight-bold Nota metodológica
          p.text Todos los scripts para replicar este análisis se encuentran en esta&nbsp;
            a(href="https://drive.google.com/drive/folders/19-fovQOPyH1a7ZcOqbjO2ytkjQOoY1KK?usp=sharing" target="_blank") carpeta
            |.
    Footer
</template>

<script>
import BlogsNavBar from "@/components/BlogsNavBar.vue";
import Scatter from "@/components/chapter3/Scatter.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Chapter3",
  components: {
    BlogsNavBar,
    Scatter,
    Footer
  },
  data() {
    return {
      blogData: {},
      titleTop: "",
      titleBottom: ""
    };
  },
  methods: {
    createTitle() {
      this.titleTop = this.blogData.title.rendered.substring(0, 23);
      this.titleBottom = this.blogData.title.rendered.substring(23);
    },
  },
  async mounted() {
    this.blogData = (await this.$store.dispatch("getBlog2")).data[0];
    //console.log(this.blogData);
    this.createTitle();
  }
};
</script>

<style lang="scss">
#chapter3 {
  #ch3intro {
    .chapter-logo {
      width: 220px;
    }
    .title {
      font-family: Oswald;
      font-size: 63px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.24;
      letter-spacing: normal;
      text-align: center;
      text-transform: uppercase;
      .top {
        color: #0a1d59;
      }
      .bottom {
        color: #f0bf5f;
      }
    }
    .author {
      font-family: "Inria Sans", sans-serif;
      font-size: 1rem;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #0a1d59;
    }
    .intro-illustration {
      width: 80%;
      max-width: 800px;
    }
    .copyright {
      font-family: "Inria Sans", sans-serif;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: italic;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #0a1d59;
    }
    .text {
      font-family: "Inria Sans", sans-serif;
      font-size: 0.9rem;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.58;
      letter-spacing: normal;
      color: #0a1d59;
    }
  }
  .section {
    .title {
      font-family: Oswald;
      font-size: 30px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.8;
      letter-spacing: normal;
      color: #0a1d59;
      background-color: #ffd58a;
    }
    .text {
      font-family: "Inria Sans", sans-serif;
      font-size: 0.9rem;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.58;
      letter-spacing: normal;
      color: #0a1d59;
    }
    .footnote {
      .number {
        font-size: 18px;
      }
      .text {
        font-size: 18px;
      }
    }
  }
}
@media (max-width: 768px) {
  #chapter3 {
    #ch3intro {
      .title {
        font-size: 3.2rem;
      }
      .text {
        font-size: 1.1rem;
      }
    }
    .section {
      .title {
        line-height: 2;
        font-size: 1.8rem;
      }
      .text {
        font-size: 1.1rem;
      }
    }
  }
}
@media (max-width: 420px) {
  #chapter3 {
    #ch3intro {
      .text {
        font-size: 1.1rem;
      }
    }
    .section {
      .title {
        font-size: 1.6rem;
      }
      .text {
        font-size: 1.1rem;
      }
    }
  }
}
</style>
